export default [
  {
    path: '/main/sync/service',
    name: 'listsyncservice',
    meta: {
      tag: 'list_sync_service',
      name: 'Sync Serviços Status',
      breadcrumb: 'Sync Serviços Status'
    },
    component: () => import(/* webpackChunkName: "service-sync-list" */ '@/views/main/sync/Services.vue')
  },
]
